export var hourlyActivityChartOptions = {
    chart: {
        backgroundColor: 'transparent',
        height: 350,
        type: 'column'
    },
    title: {
      text: 'Hourly Activity'
    },
    xAxis: {
      categories: []
    },
    yAxis: {
      title: {
        text: 'Actions'
      }
    },
    credits: {
      enabled: false
    },
    navigation: {
      buttonOptions: {
          enabled: false
      }
    },
    series: [{
      name: 'Actions',
      showInLegend: false,
      data: []
    }]
};

export var dailyActivityChartOptions = {
    chart: {
        height: 350,
        backgroundColor: 'transparent',
        type: 'column'
    },
    title: {
        text: 'Daily Activity'
    },
    xAxis: {
        categories: []
    },
    yAxis: {
        title: {
            text: 'Actions'
        }
    },
    credits: {
        enabled: false
    },
    navigation: {
        buttonOptions: {
            enabled: false
        }
    },
    series: [{
        name: 'Actions',
        showInLegend: false,
        data: []
    }]
};
  
export var groupScoresChartOptions = {
    chart: {
      backgroundColor: 'transparent',
      type: 'bar'
    },
    title: {
      text: 'Group Scores'
    },
    xAxis: {
      categories: []
    },
    yAxis: {
      min: 0,
      max: 100,
      title: {
        text: 'Score %'
      }
    },
    legend: {
      reversed: true
    },
    plotOptions: {
      series: {
        stacking: 'normal',
        events: {
          legendItemClick: () => false
        }
      }
    },
    series: [],
    credits: {
      enabled: false
    }
  };
    
  export var enagementChartOptions = {
    chart: {
      backgroundColor: 'transparent',
      type: 'solidgauge',
      spacingBottom: -210, // Need to cut off some whitespace because only using 'half' a gauge
      events: {
        click: () => {
          this.chartClicked.emit(null);
        }
      }
    },
    title: null,
    yAxis: {
      min: 0,
      max: 100,
      title: null,
      stops: [
        [0.1, '#df787a'], // red
        [0.5, '#ffda3d'], // yellow
        [0.9, '#7bc868'] // green
      ],
      lineWidth: 0,
      minorTickInterval: 10,
      tickAmount: 0,
      labels: {
        y: 16
      }
    },
    series: [{
      name: 'Engagement',
      data: [0],
      dataLabels: {
        format: '<div style="text-align:center">' +
          '<span style="text-transform:uppercase;font-size:20px;color:#666">Engagement</span>' +
          '</div>' +
          '<div style="text-align:center"><span style="font-size:48px;color:#666">{y}%</span><br/></div>'
      },
      tooltip: {
        valueSuffix: '%'
      }
    }],
    pane: {
      // center: ['50%', '85%'],
      size: '100%',
      startAngle: -90,
      endAngle: 90,
      background: {
        backgroundColor: '#FFF',
        innerRadius: '60%',
        outerRadius: '100%',
        shape: 'arc'
      }
    },
    tooltip: {
      enabled: false
    },
    plotOptions: {
      solidgauge: {
        dataLabels: {
          y: -15,
          borderWidth: 0,
          useHTML: true
        }
      }
    },
    credits: {
      enabled: false
    }
  };